import {
    GET_RENEWAL_CONFIG_REQUEST,
    GET_RENEWAL_CONFIG_SUCCESS,
    GET_RENEWAL_CONFIG_FAILURE,
    UPDATE_RENEWAL_CONFIG_REQUEST,
    UPDATE_RENEWAL_CONFIG_SUCCESS,
    UPDATE_RENEWAL_CONFIG_FAILURE,
} from '../actions/renewalConfigs';

const initialState = {
    config: null,
    fetching: false,
    updating: false,
    error: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_RENEWAL_CONFIG_REQUEST:
            return { ...state, fetching: true, config: null, error: null };
        case GET_RENEWAL_CONFIG_SUCCESS:
            return { ...state, fetching: false, config: action.payload.config };
        case GET_RENEWAL_CONFIG_FAILURE:
            return { ...state, fetching: false, error: action.payload.error };

        case UPDATE_RENEWAL_CONFIG_REQUEST:
            return { ...state, updating: true, error: null };
        case UPDATE_RENEWAL_CONFIG_SUCCESS:
            return { ...state, updating: false, config: action.payload.config };
        case UPDATE_RENEWAL_CONFIG_FAILURE:
            return { ...state, updating: false, error: action.payload.error };

        default:
            return state;
    }
};
